<template>
  <div class="dialog">
    <div class="dialog-wrap">
      <!-- 登录弹框 -->
      <div class="login-dialog" v-if="currentStep == 0">
        <div class="dialog-head">
          <div class="login-icon"></div>
          <div class="login-title">文华hr系统</div>
          <div class="close-icon" @click="close"></div>
        </div>
        <div class="dialog-body">
          <div class="input-wrap">
            <input type="text" placeholder="应聘档案号/手机号" v-model="phone" />
          </div>
          <div class="input-wrap">
            <input type="text" placeholder="验证码" class="code-input" v-model="code" />
            <div class="send-code" @click="sendCode">{{codeText}}</div>
          </div>
          <div class="warn-msg">{{loginMsg}}</div>
        </div>
        <div class="dialog-bottom" @click="login">登&nbsp;&nbsp;录</div>
      </div>
      <!-- 基本信息弹框 -->
      <div class="login-dialog" v-if="currentStep == 1">
        <div class="dialog-head">
          <div class="applay-icon"></div>
          <div class="login-title">申请职位</div>
          <div class="close-icon" @click="close"></div>
        </div>
        <div class="dialog-body">
          <div class="base-input" :class="{'border': focusIndex == 0}" @click="trigger(0)">
            <span class="input-label">来源</span>
            <span class="select-value">{{source}}</span>
            <span id="trigger-source" style="display:none;"></span>
            <span class="select-icon"></span>
          </div>
          <div class="base-input" :class="{'border': focusIndex == 1}" @click="trigger(1)">
            <span class="input-label">职位</span>
            <span class="select-value">{{position}}</span>
            <span id="trigger-position" style="display:none;"></span>
            <span class="select-icon"></span>
          </div>
          <div
            class="base-input"
            :class="{'border': focusIndex == 2}"
            @click="trigger(2)"
            v-show="isShowPlace"
          >
            <span class="input-label">地点</span>
            <span class="select-value">{{place}}</span>
            <span id="trigger-place" style="display:none;"></span>
            <span class="select-icon"></span>
          </div>
          <div class="base-input" :class="{'border': focusIndex == 3}" @click="focusIndex = 3">
            <span class="input-label">姓名</span>
            <input type="text" class="username" v-model="username" />
          </div>
          <div class="warn-msg">{{baseInfoMsg}}</div>
        </div>
        <div class="dialog-bottom" @click="confirmBaseInfo">确定</div>
      </div>
      <!-- 输入基本信息后的提示框 -->
      <div class="login-dialog" v-if="currentStep == 3">
        <div class="dialog-head">
          <div class="applay-icon"></div>
          <div class="login-title">提示</div>
          <div class="close-icon" @click="close"></div>
        </div>
        <div class="dialog-body">
          <div class="info-text">网申完成后，HR将于2个工作日内进行审核，审核通过HR会第一时间与您联系。</div>
          <div class="warn-info-text">提示：如中途退出，下次请用相同的档案号/手机号登录。</div>
        </div>
        <div class="dialog-bottom" @click="nowStart">
          <div class="online-bottom">现在开始</div>
        </div>
      </div>
      <!-- 已登录的提示框 -->
      <div class="login-dialog" v-if="currentStep == 2">
        <div class="dialog-head">
          <div class="login-icon"></div>
          <div class="login-title">提示</div>
          <div class="close-icon" @click="close"></div>
        </div>
        <div class="dialog-body">您已申请过职位</div>
        <div class="dialog-bottom" @click="goTest">
          <div class="online-bottom">点此继续完成网申环节</div>
        </div>
      </div>
      <!-- 其他提示信息 -->
      <div class="login-dialog" v-if="currentStep == 999">
        <div class="dialog-head">
          <div class="login-icon"></div>
          <div class="login-title">提示</div>
          <div class="close-icon" @click="close"></div>
        </div>
        <div class="dialog-body">{{warnMessage}}</div>
        <div class="dialog-bottom" @click="close">
          <div class="online-bottom">确定</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MobileSelect from "mobile-select";

export default {
  props: {
    step: {
      // 当前步骤，对应各弹窗
      type: Number,
      default: 0,
    },
    url: {
      // 已登录并已申请过职位时的url
      type: String,
      default: "",
    },
    jobs: {
      // 工作列表
      type: Array,
      default: [],
    },
    currentPosition: {
      // 当前职位名称
      type: String,
      default: "",
    },
    fromPage: {
      type: String,
      default: "",
    }
  },
  data() {
    return {
      // 登录弹框
      testUrl: this.url, // 网侧地址
      phone: "", // 用户电话
      code: "", // 验证码
      loginMsg: "", // 提示信息
      codeText: "获取验证码",
      isSendCode: false, // 是否发送

      currentStep: this.step, // 当前步骤

      // 申请职位弹框
      source: "---", // 来源
      // sourceList: [
      //   { id: 16, value: '---' },
      //   { id: 15, value: "校园招聘" },
      //   { id: 1, value: "智联招聘" },
      //   { id: 10, value: "boss直聘" },
      //   { id: 5, value: "推荐" },
      //   { id: 12, value: "拉勾网" },
      //   { id: 13, value: "猎头" },
      //   { id: 21, value: "牛客优聘" },
      //   { id: 22, value: "24365" },
      //   { id: 23, value: "实习僧" },
      //   { id: 24, value: "毕业申" },
      // ],
      sourceNum: 16, // 来源数值(默认)
      position: "---", // 职位名称
      jobList: [], // 工作列表
      jobid: 1, // 工作id
      place: "---", // 地点
      placeId: null,  // 地点id
      placeList: [{id: -1, value: '---'}], // 地点列表
      palceMap: {  // 地点列表map
        0: '大连',
        1: '上海',
        // 2: '深圳',
        3: '苏州'
      },
      username: "", // 用户名
      baseInfoMsg: "", // 提示信息
      isShowPlace: false, // 是否显示地点选框

      focusIndex: -1,     // 点击的输入框

      warnMessage: '',

      mobileSelect1: null,
      mobileSelect2: null,
      mobileSelect3: null,
      initialPlaces: {}
    };
  },
  computed: {
    sourceList() {
      return this.$store.state.sourceList;
    },
  },
  created() {
    // 是否有默认选项,在申请页面点击申请工作按钮,有对应职位名称
    let that = this;
    this.$nextTick(() => {
      if (that.currentPosition) {
        // 列表
        that.jobs.forEach((item, index) => {
          if (that.currentPosition == item.position) {
            that.initialPlaces = item;
            if (item.city_arr && item.city_arr.length > 1) {
              // 城市选择不止一个的显示地点
              that.isShowPlace = true; // 控制地点显示
            } else {
              that.isShowPlace = false; // 控制地点显示
            }
            that.position = item.position;
            that.jobid = item.id;
            return;
          }
        });
      }
    });
  },
  mounted() {
    if (this.currentStep == 1) {
      // 进入时就是步骤1，初始化默认值，注册下拉
      let that = this;
      that.$nextTick(() => {
        that.regSelect();
        that.setPlaces(that.initialPlaces)
      });
    }
  },
  methods: {
    setPlaces(data) {
      let that = this;
      that.placeList = [{id: -1, value: '---'}], that.place = '---', that.placeId = null;
      if (data.city_arr && data.city_arr.length > 1) {
        data.city_arr.forEach(function(val, index) {
          that.placeList.push({id: val, value: that.palceMap[val]});
        })
        that.isShowPlace = true; // 控制地点显示
      } else {
        that.isShowPlace = false; // 控制地点显示
      }

      that.position = data.position;
      that.jobid = data.id;
      
      if (that.placeList.length) {  // 注册地点
        that.mobileSelect3.updateWheel(0, that.placeList);
      }
    },
    // 关闭弹框
    close() {
      this.$emit("closeDialog");
    },
    // 登录
    login() {
      this.loginMsg = "";
      if (this.phone == "") {
        this.loginMsg = "请输入应聘档案号或手机号";
        return;
      }
      if (this.code == "") {
        this.loginMsg = "请输入验证码";
        return;
      }
      this.$http
        .post("/User/Login", { phone: this.phone, code: this.code })
        .then((res) => {
          if (res.status != 200 || !res.data) return;

          let loginData = res.data;
          if (loginData.status) {
            if (this.fromPage == 'main') {
              if (loginData.data.status == 0) return this.close();
              return window.location.href = '/Job/FullTest';
            }

            this.testUrl = loginData.data.url;
            if (loginData.data.status == 1) {
              this.currentStep = 2;
            } else {
              // 基本信息
              this.currentStep = 1;
              var that = this;
              that.$nextTick(() => {
                that.regSelect();
                that.setPlaces(that.initialPlaces)
              });
            }
          } else {
            this.loginMsg = loginData.message;
          }
        });
    },
    // 发送验证码
    sendCode() {
      if (this.isSendCode) return;
      if (this.phone == "") {
        this.loginMsg = "请输入应聘档案号或手机号";
        return;
      } else {
        this.loginMsg = "";
      }
      var that = this;
      var i = 120;
      var timer = setInterval(function () {
        if (i == 0) {
          that.isSendCode = false;
          that.codeText = "重新获取";
          clearInterval(timer);
        } else {
          that.isSendCode = true;
          that.codeText = "正在发送(" + i + "s)";
        }
        i--;
      }, 1000);

      this.$http
        .post("/Captcha/SendValidCode", { telNumber: this.phone })
        .then((res) => {
          let {message, status} = res?.data;
          if (res.status != 200 || !res.data || !status) {
            this.loginMsg = !status ? message : '';
            this.isSendCode = false;
            this.codeText = "获取验证码";
            clearInterval(timer);
          }
        });
    },
    // 开始网申
    goTest() {
      window.open(this.testUrl);
      this.close();
    },
    nowStart() {
      window.open(
        "http://job.wenhua.com.cn/Home/Index?username=" +
          escape(this.username) +
          "&pwd=" +
          escape(this.phone)
      );
      this.close();
    },
    // 填写基本信息
    confirmBaseInfo() {
      // 验证信息
      this.baseInfoMsg = "";
      if (this.isShowPlace && this.place == "---") {
        this.baseInfoMsg = "请选择工作地点";
        return;
      }
      if (this.username == "") {
        this.baseInfoMsg = "姓名不能为空！";
        return;
      }

      var params = {
        job: this.position, // position
        name: this.username,
        isSource: this.sourceNum,
        jobid: this.jobid == -1 ? '' : this.jobid,
        city: this.isShowPlace ? this.placeId : ''
      };

      this.$http.post("/Job/JobApply", params).then((res) => {
        if (res.status != 200 || !res.data) return;
        if (res.data.status) {
          this.phone = res.data.data.phone;
          this.username = res.data.data.name;
          this.currentStep = 3;
        } else {
          this.currentStep = 999;
          this.warnMessage = res.data.message;
        }
      });
    },
    // 注册下拉插件
    regSelect() {
      this.jobList = [{
        id: -1,
        position: "---",
        city_arr: [],
      }];
      this.jobs.forEach((item, index) => {
        this.jobList.push({
          id: item.id,
          position: item.position,
          city_arr: item.city_arr,
        });
      });
      var that = this;
      that.mobileSelect1 = new MobileSelect({
        trigger: "#trigger-source",
        title: "请选择",
        wheels: [{ data: that.sourceList }],
        initValue: "---",
        callback: function (indexArr, data) {
          that.source = data[0].value;
          that.sourceNum = data[0].id;
        },
      });
      that.mobileSelect3 = new MobileSelect({
        trigger: "#trigger-place",
        title: "请选择",
        wheels: [{ data: that.placeList }],
        callback: function (indexArr, data) {
          that.place = data[0].value;
          that.placeId = data[0].id;
        },
      });
      that.mobileSelect2 = new MobileSelect({
        trigger: "#trigger-position",
        title: "请选择",
        wheels: [{ data: that.jobList }],
        keyMap: {
          id: "id",
          value: "position"
        },
        initValue: that.currentPosition,
        callback: function (indexArr, data) {
          that.setPlaces(data[0]);
        },
      });
    },
    // 点击对应项目，显示下拉
    trigger(type) {
      if (type == 0) {
        this.focusIndex = 0;
        document.getElementById('trigger-source').click();
      } else if (type == 1) {
        this.focusIndex = 1;
        document.getElementById('trigger-position').click();
      } else if (type == 2) {
        this.focusIndex = 2;
        document.getElementById('trigger-place').click();
      }
    }
  },
};
</script>

<style scoped>
.dialog {
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.65);
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 99;
  display: flex;
  justify-content: center;
  align-items: center;
}
.dialog-wrap {
  /* min-width: 8rem; */
  word-break: break-all;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
}
.login-dialog {
  border-radius: 0.2em;
  overflow: hidden;
  max-width: 90%;
  min-width: 12rem;
}
.dialog-head {
  color: rgb(65, 65, 65);
  background: rgb(240, 240, 240);
  padding: 0.4rem 0.4rem;
  font-size: 0.6rem;
  border-bottom: 1px solid rgb(190, 190, 190);
}
.login-icon {
  display: inline-block;
  height: 0.8rem;
  width: 0.8rem;
  background: url(../../assets/img/login.png) no-repeat center/cover;
  vertical-align: middle;
  margin-right: 0.4rem;
}
.login-title {
  display: inline-block;
  vertical-align: middle;
  font-size: 0.6rem;
  line-height: 0.8rem;
}
.close-icon {
  float: right;
  height: 0.8rem;
  width: 0.8rem;
  background: url(../../assets/img/dialog_icon2.png) no-repeat center/cover;
  vertical-align: middle;
}
.warn-msg {
  color: red;
  font-size: 0.6rem;
  height: 0.6rem;
  width: 100%;
  margin: 0 auto;
  text-align: left;
}
input {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  border: 1px rgb(190, 190, 190) solid;
  display: inline-block;
  font-size: 0.6rem;
  padding: 0.2rem;
}
input:focus {
  outline: none;
  border-color: rgb(243, 137, 0);
}
.input::-webkit-input-placeholder {
  font-size: 0.6rem;
}
.input::placeholder {
  font-size: 0.6rem;
}
.code-input {
  width: 50%;
  float: left;
}
.input-wrap {
  position: relative;
  height: 1.5rem;
  margin-bottom: 0.5rem;
}
.send-code {
  width: 49%;
  height: 100%;
  line-height: 1.5rem;
  text-align: center;
  border: solid;
  background-color: rgb(240, 240, 240);
  font-size: 0.6rem;
  border: 1px rgb(190, 190, 190) solid;
  float: right;
  box-sizing: border-box;
  min-width: 4.5rem;
}
.applay-icon {
  display: inline-block;
  height: 0.8rem;
  width: 0.8rem;
  background: url(../../assets/img/dialog_icon1.png) no-repeat center/cover;
  vertical-align: middle;
  margin-right: 0.4rem;
}
.dialog-body {
  color: rgb(65, 65, 65);
  background: #fff;
  padding: 1rem;
  font-size: 0.6rem;
  text-align: center;
}
.dialog-bottom {
  color: rgb(65, 65, 65);
  background: rgb(240, 240, 240);
  padding: 0.6em 0;
  text-align: center;
  font-size: 0.6rem;
  border-top: 1px solid rgb(190, 190, 190);
}
.online-bottom {
  padding: 0 0.8rem;
}
.base-input {
  height: 1.5rem;
  width: 100%;
  margin: 0 auto 0.5926rem auto;
  border: 1px solid rgb(190, 190, 190);
  position: relative;
  text-align: left;
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
  padding: 0.2rem;
  font-size: 0.6rem;
  display: table;
}
.border {
  border-color: rgb(243, 137, 0);
}
.base-input input {
  border: none;
  outline: none;
  padding: 0;
}
.base-input:last-of-type {
  margin-bottom: 0;
}
.input-label {
  display: table-cell;
  vertical-align: middle;
  width: 20%;
}
.select-value {
  display: table-cell;
  vertical-align: middle;
  width: 70%;
}
.select-icon {
  display: table-cell;
  position: relative;
}
.select-icon::after {
  content: '';
  height: 1rem;
  width: 1rem;
  background: url(../../assets/img/select.png) no-repeat center/auto;
  background-size: 100% 100%;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}
.username {
  display: table-cell;
  vertical-align: middle;
}
.info-text {
  color: blue;
  text-align: left;
}
.warn-info-text {
  margin-top: 0.508rem;
  color: red;
  text-align: left;
}
</style>